import { CheckoutAccountFormModule } from './accountForm/accountForm';
import { CheckoutHelpModule } from './help/help';
import { CheckoutInfoModule } from './info/info';
import { CheckoutLoginFormModule } from './loginForm/loginForm';
import { CheckoutOrderSummaryModule } from './orderSummary/orderSummary';
import { CheckoutSignupFormModule } from './signupForm/signupForm';
import { CheckoutThankYouModule } from './thankYou/thankYou';
import { CheckoutUserInfoModule } from './userInfo/userInfo';
import { PaymentMethodModule } from './paymentMethodSelector/paymentMethodSelector';

export const CheckoutComponentsModule = angular
    .module('app.components.checkout.components', [
        CheckoutAccountFormModule,
        CheckoutHelpModule,
        CheckoutInfoModule,
        CheckoutLoginFormModule,
        CheckoutOrderSummaryModule,
        CheckoutSignupFormModule,
        CheckoutThankYouModule,
        CheckoutUserInfoModule,
        PaymentMethodModule
    ])
    .name;



// WEBPACK FOOTER //
// ./src/app/components/checkout/components/checkoutComponents.module.js